import { FREE_PLAN, PLAN_FEATURES } from '@scio3/shared-types';
import { useBillingDialogStore } from '@/features/billing/stores/billing-dialog-store';
import { useAuthStore } from '@/stores/auth-store';

type CompanyPlan = {
  feature?: { allowTeams?: boolean | null } | null;
  payment?: { planFeature?: string | null } | null;
} | null;

/** Free and Standard don't include teams. The server refuses the create there too. */
export function planIncludesTeams(company: CompanyPlan | undefined): boolean {
  return !!company?.feature?.allowTeams && company.payment?.planFeature !== FREE_PLAN;
}

/** The shared upgrade popup, asking for the first plan that includes teams. */
export function openTeamsUpgrade(): void {
  useBillingDialogStore.getState().openDialog('upgradeRequired', {
    minPlanRequired: PLAN_FEATURES.PRO_PLUS,
    currentPlan: useAuthStore.getState().company?.payment?.planFeature ?? '',
  });
}
